export default __webpack_public_path__ + "static/media/ic_requests_active.42a53a1c.svg";